import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"
import { registerEventListeners } from "@/modules/login/events/event-register"

const registerLoginModule: ModuleRegisterFn = (context: ModuleRegisterContext) => {
  registerEventListeners(context.eventBus)
  console.log("login module registered!")
}

export default registerLoginModule
